import { getCookie, addCookie } from '@/ask/cookiejs.js'
export default {
  install(Vue, options) {
    Date.prototype.Format = function (fmt) {

      if (!this.Valid()) {
        return '';
      }

      var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
      };

      if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      return fmt;
    },

      //判断是否有效日期
      Date.prototype.Valid = function () {
        return isFinite(this);
      }

    //注意：此方法会导致阻塞，请慎用
    //等待funCheck的验证通过后，执行funRun
    //funCheck验证方法，此方法必须返回bool型
    //funRun需执行的方法
    //maxWaitMillisecond最多等待时间（单位：毫秒）
    Vue.prototype.waitRun = function (funCheck, funRun, maxWaitMillisecond) {
      //console.log(maxWaitMillisecond + " " + new Date());
      if (maxWaitMillisecond == null || maxWaitMillisecond == undefined) {
        maxWaitMillisecond = 1000 * 10; //默认最多等待10秒
      }

      if (funCheck() == true || maxWaitMillisecond <= 0) { //验证通过，或等待时间已过 执行方法
        funRun();
      } else { //验证不通过，等待
        setTimeout(() => { this.waitRun(funCheck, funRun, maxWaitMillisecond - 100); }, 100);
      }
    },

      //当小数不足bit时，不补0，超过bit 截取bit位
      // num 数字  bit 位数
      Vue.prototype.InterceptUnit = function (num, bit) {
        if (isNaN(num)) {
          return 0
        }
        return parseFloat(Number(num).toFixed(bit))
      }
    Vue.prototype.AmountNameGet = function (id) {
      if (id == 1) return '￥';
      if (id == 2) return 'US $';
      if (id == 3) return 'HK $';
      if (id == 4) return '€';
    }
    Vue.prototype.addNum = function (arg1, arg2) {
      var r1, r2, m, n;
      try { r1 = arg1.toString().split(".")[1].length } catch (e) { r1 = 0 }
      try { r2 = arg2.toString().split(".")[1].length } catch (e) { r2 = 0 }
      m = Math.pow(10, Math.max(r1, r2));
      //last modify by deeka
      //动态控制精度长度
      n = (r1 >= r2) ? r1 : r2;
      return ((arg1 * m - arg2 * m) / m).toFixed(n);
    }

    //=============埋点查询=====================// document.title

    let SalesInfos = JSON.parse(sessionStorage.getItem('SalesInfos'));
    let isLogin = false
    if (getCookie('X-BY-EnTOKEN') !== 'null') {
      isLogin = true
    }
    let isVip = false
    //注册公共属性 初始化一次
    sensors.registerPage({
      platform_type: 'web',
      app_name: '电商web端',
      is_vip: Boolean(isVip),
      is_login: Boolean(isLogin),
    });
    //登录后获取值
    if (SalesInfos) {
      sensors.login(SalesInfos.CustomerID)
    }


    //登录-
    Vue.prototype.loginResult = function (iSsuccess, failReason) {
      sensors.track('login_result', {
        login_method: '邮箱',
        is_quick_login: false,
        is_success: iSsuccess,
        fail_reason: failReason,
      });
    }

    //注册-点击提交按钮
    Vue.prototype.clkButton = function () {
      sensors.track('register_button_click', {
        entrance: document.title,
      });
    }
    //注册-点击按钮进行验证
    Vue.prototype.clkButtonState = function (iSsuccess, failReason) {
      sensors.track('click_to_verify', {
        is_success: iSsuccess,
        fail_reason: failReason,
      });
    }
    //注册-获取code
    Vue.prototype.clkVerify = function (iSsuccess, failReason, time) {
      sensors.track('verify_result', {
        is_success: iSsuccess,
        fail_reason: failReason,
        return_duration: Number(time),
      });
    }
    //注册-获取code结果
    Vue.prototype.getCodeResult = function (serviceType, getType, iSsuccess, failReason) {
      sensors.track('get_code_result', {
        service_type: serviceType,
        get_type: getType,
        is_success: iSsuccess,
        fail_reason: failReason,
      });
    }

    //注册-注册结果
    Vue.prototype.regResult = function (iSsuccess, failReason) {
      sensors.track('register_result', {
        registration: '注册客户',
        is_success: iSsuccess,
        fail_reason: failReason,
      });
    }

    //查价
    Vue.prototype.checkPrice = function (transType, startText, startCountry, desText, desCountry, packetType, weight, cbm, quantity, isGoods, goodsText, clearance, airType) {
      sensors.track('price_query', {
        entrance: document.title,
        service_type_trans: transType,
        location_of_departure: startText, //出发地
        country_of_departure: startCountry, //出发国家
        location_of_destination: desText, //目的地的
        country_of_destination: desCountry,//目的国家
        package_type: packetType,//包裹类型
        weight: Number(weight),
        volume: Number(cbm),
        total_number: Number(quantity),
        contain_prohibited_goods_or_not: isGoods,
        goods_contain: goodsText,
        is_need_customs_clearance: clearance,//是否需要清关服务
        air_service_type: airType,//空运服务类型
      });
      //console.log("进来了吗======");
    }

    //埋点-返回搜索结果
    Vue.prototype.searchResult = function (number, transType, startText, startCountry, desText, desCountry, preferred) {
      sensors.track('search_result', {
        results_number: Number(number),
        service_type_trans: transType,
        location_of_departure: startText, //出发地
        country_of_departure: startCountry, //出发国家
        location_of_destination: desText, //目的地的
        country_of_destination: desCountry,//目的国家
        contain_preferred_or_not: preferred,//是否百运优选
      });
      //console.log("进来了吗======");
    }

    //埋点-提交订单
    Vue.prototype.submitOrder = function (orderId, orderAmount, orderActualAmount, transType, startText, startCountry, desText, desCountry, goodsType, weight, volume, totalNumber, billingW, invType, channelName, costs, discountName, discountAmount, isUseDiscount) {
      try {
        sensors.track('submit_order', {
          order_id: orderId,
          order_amount: Number(orderAmount),
          order_actual_amount: Number(orderActualAmount),
          service_type_trans: transType,
          location_of_departure: startText, //出发地
          country_of_departure: startCountry, //出发国家
          location_of_destination: desText, //目的地的
          country_of_destination: desCountry,//目的国家
          goods_type: goodsType,
          weight: Number(weight),
          volume: Number(volume),
          total_number: Number(totalNumber),
          billing_w: Number(billingW),
          inv_type: invType,
          saller: SalesInfos.SalesName,
          customer_service: SalesInfos.KFName,
          channel_name: channelName,
          transportation_costs: Number(costs),
          discount_name: discountName,
          discount_amount: Number(discountAmount),
          is_use_discount: isUseDiscount,
          entrance: document.title,
        });
      } catch (error) {
        console.warn(error);
      }

    }

    //埋点-提交询价
    Vue.prototype.submitInquiry = function (startText, startCountry, desText, desCountry, weight, serviceType, volume, billingW, totalNumber, goodsType) {
      sensors.track('inquiry', {
        location_of_departure: startText, //出发地
        country_of_departure: startCountry, //出发国家
        location_of_destination: desText, //目的地的
        country_of_destination: desCountry,//目的国家
        weight: Number(weight),
        service_type: serviceType,
        volume: Number(volume),
        billing_w: Number(billingW),
        total_number: Number(totalNumber),
        goods_type: goodsType,
        entrance: document.title,
      });
    }

    //埋点-浏览询盘结果
    Vue.prototype.viewResult = function (inquiryId, startText, startCountry, desText, desCountry, weight, serviceType, volume, billingW, totalNumber, goodsType) {
      sensors.track('view_inquiry_result', {
        inquiry_id: inquiryId,
        location_of_departure: startText, //出发地
        country_of_departure: startCountry, //出发国家
        location_of_destination: desText, //目的地的
        country_of_destination: desCountry,//目的国家
        weight: Number(weight),
        service_type: serviceType,
        volume: Number(volume),
        billing_w: Number(billingW),//是否百运优选
        total_number: Number(totalNumber),
        goods_type: goodsType,
      });
    }

    //埋点-充值
    Vue.prototype.recharge = function (amount, payType, payMode, isSuccess) {
      sensors.track('recharge', {
        recharge_amount: Number(amount),
        pay_type: payType,
        pay_mode: payMode,
        is_success: isSuccess,
        entrance: document.title,
      });
    }
  },
}

//防抖。防止按钮多次重复多次点击
export function _debounce(fn, delay) {
  var delay = delay || 200;
  var timer;
  return function () {
    var th = this;
    var args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      timer = null;
      fn.apply(th, args);
    }, delay);
  };
}

// 写入Generalcargo  
export function Generalcargo(FlagVal, index) {
  let everyTimeVal = JSON.parse(getCookie('En-Generalcargo'))
  if (!everyTimeVal) {
    // 为方便操作 直接将下标指定 0 快递 1 专线 2 空运 3 FBA  4小包
    everyTimeVal = [0, 0, 0, 0, 0]
  }
  everyTimeVal[index] = (FlagVal === false ? 1 : 0) // 1 代表选中了
  everyTimeVal = JSON.stringify(everyTimeVal)
  //console.log(everyTimeVal)
  addCookie('En-Generalcargo', everyTimeVal, 365, '/')
}





// WEBPACK FOOTER //
// ./src/ask/util.js